import { render, staticRenderFns } from "./MagicoModal.vue?vue&type=template&id=1216c385"
import script from "./MagicoModal.vue?vue&type=script&lang=js"
export * from "./MagicoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports